/**
 * Special ID used to filter for conversations with no assigned user
 */
export const UNASSIGNED_USER_ID = -1;
